import { WishlistApp } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.20.11/wishlist-app.js";

export const createApp = ({ settings, config, locale }) => {
  if (window.WishlistKing) {
    return;
  }

  const app = new WishlistApp({
    config,
    settings,
    locale,
    dependencies: [
      "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.20.11/components/wishlist.css",
      "//ohvault.com/cdn/shop/t/49/assets/wishlist-king-custom.css?v=57335467104778990221729664453",
      "//ohvault.com/cdn/shop/t/49/assets/wishlist-king-components.js?v=17122269280229092751729664453",
    ],
  });

  initEvents(app);
  initComponents(app);

  return app;
};

const initComponents = ({ theme, routes }) => {
  // Header link
  theme.watch(
    {
      selector: ".js-drawer-open-cart",
    },
    (target) => {
      target.insertBefore(
        theme.createComponent("wishlist-link", {
          props: {
            layout: "icon-only",
            alignment: "center",
            badgeLayout: "pill-only",
            badgeParentheses: false,
            badgeHiddenIfEmpty: true,
            badgeFloating: {
              position: {
                placement: "top-end",
                inset: true,
              },
              offset: 0,
            },
          },
        })
      );
    }
  );

  // Grid items
  theme.watch(
    {
      selector: `.grid-product__content > .grid-product__link[href*="/products/"]`,
      pageType: ["home", "product", "collection"],
      skipHidden: true,
    },
    (target) => {
      target.insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(target.element.href),
            variantId: theme.getVariantId(target.element.href),
          },
          props: {
            layout: "icon-only",
            icon: "wishlist",
            floating: {
              reference: target,
              position: {
                placement: "top-start",
                inset: true,
              },
              offset: 0,
            },
          },
        })
      );
    }
  );

  // Product page
  theme.watch(
    {
      selector: `.product-single__form`,
      pageType: ["product"],
    },
    (target) => {
      target.insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(document.location.href),
            variantId: theme.getVariantId(document.location.href),
          },
          props: {
            layout: "icon-and-text",
            alignment: "center",
            fullWidth: true,
            outline: false,
          },
        })
      );
    }
  );

  // Wishlist page
  theme.watch(
    {
      selector: "#wishlist-page",
    },
    (target) => {
      target.replace(
        theme.createComponent("wishlist-page", {
          dataset: {
            wishlistId: theme.getWishlistId(window.location.pathname),
          },
        })
      );
    }
  );
};

const initEvents = (app) => {
  app.events.subscribe("wk:wishlist:add-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
    // document.dispatchEvent(
    //   new CustomEvent("ajaxProduct:added", {
    //     detail: {
    //       product: event.data.product,
    //     },
    //   })
    // );
  });
  app.events.subscribe("wk:wishlist:add-all-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:login-required", (event) => {
    const ignoreActions = ["wishlist:private:load"];
    if (!ignoreActions.includes(event.data.action)) {
      window.location.href = app.routes.accountLoginUrl;
    }
  });
};
